import { useCallback, useState } from 'react'
// import SelectBox from '../../components/SelectBox'
import InputField from '../../../components/InputField'
import ApiRoute from '../../../components/ApiRoute'

const Fips = ({ callApiFn, isApiCalling }) => {
  const [zip, setZip] = useState('')

  const getFipsByZip = useCallback(() => {
    callApiFn({
      method: 'GET',
      route: `fips/${zip}`
    })
  }, [zip])

  return (
    <div className='flex flex-row items-end'>
      <InputField
        labelFor='zip'
        type='text'
        id='zip'
        name='zip'
        onChange={(e) => setZip(e.target.value)}
        value={zip}
      >Zip Code
      </InputField>
      <div className='mx-2'>
        <ApiRoute method='GET' route='/fips/{zipCode}' onClick={getFipsByZip} disabled={isApiCalling} />
      </div>
    </div>
  )
}

export default Fips
